var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStop = function SvgStop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "usuario",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.95 16.56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a9a9a9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.11.16s-.05,0-.08,0C3.39.06.36,2.93.26,6.57c.06,5.48,6.78,9.84,6.78,9.84,0,0,6.61-4.22,6.66-9.84C13.64,2.98,10.7.11,7.11.16Zm-.08,14.78c-1.59-1.19-5.54-4.55-5.58-8.37.11-2.98,2.6-5.31,5.58-5.21,2.92-.1,5.36,2.18,5.46,5.1,0,.03,0,.07,0,.1-.04,3.92-3.89,7.21-5.46,8.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.97,3.21h0c-1.93,0-3.49,1.56-3.49,3.49,0,1.93,1.56,3.49,3.49,3.49,1.93,0,3.49-1.56,3.49-3.49s-1.56-3.49-3.49-3.49Zm0,5.78c-1.26,0-2.29-1.03-2.29-2.29,0-1.27,1.03-2.29,2.29-2.29,1.27,0,2.29,1.03,2.29,2.29,0,1.27-1.03,2.29-2.29,2.29Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "stop.f31441f18d96d5e1083724a623feccbc.svg";